module.exports = __webpack_public_path__ + "media/images/emblems/Haegendorf-blason-e902c3bc6dfb624932bde57d191317c7.png";